import { getLanguageCode } from "./language";

export const formatNumberWithLocale = (
  value: number,
  options?: Intl.NumberFormatOptions,
): string => {
  const locale = getLanguageCode();
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
    ...options,
  }).format(value);
};

/**
 * Format a price with the correct locale.
 * Shows two decimal places if the value has decimals, otherwise shows no decimals.
 * This ensures that prices like "2 897,1 SEK" are displayed as "2 897,10 SEK",
 * while whole numbers like "2 897 SEK" are displayed without decimals.
 */
export const formatPriceWithLocale = (
  value: number,
  options?: Intl.NumberFormatOptions,
): string => {
  const locale = getLanguageCode();
  const hasDecimals = Math.abs(value % 1) > Number.EPSILON;
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
    minimumFractionDigits: hasDecimals ? 2 : 0,
    ...options,
  }).format(value);
};
